import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { VertexFormComponent } from './vertex-form/vertex-form.component';

@NgModule({
  declarations: [VertexFormComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class VertexesModule { }
